import Enum from '@/shared/models/enums/enum';

class WorkSubmitStatus extends Enum {
    static PENDING = 1; // 未提出
    static TEMPORARY = 2; // 下書き
    static SUBMITTED = 5; // 提出済
    static NOT_REQUIRED = 9; // 提出不要

    static values() {
        return {
            [this.PENDING]: '未提出',
            [this.TEMPORARY]: '下書き',
            [this.SUBMITTED]: '提出済',
            [this.NOT_REQUIRED]: '提出不要',
        }
    }
}

export default WorkSubmitStatus;
